import React from "react";

const Flag = ({ text }) => (
  <div className="expano-flag">
    <span>{text}</span>
  </div>
);

export default Flag;
